(function () {
  'use strict';

  function install(template) {
    if (!template || template.dataset.shFontLoaded === 'true') return;
    template.dataset.shFontLoaded = 'true';

    var key = template.getAttribute('data-sh-font-key') || '';
    if (key) {
      var existing = Array.prototype.some.call(document.head.querySelectorAll('style[data-sh-font-key]'), function (node) {
        return node.getAttribute('data-sh-font-key') === key;
      });
      if (existing) return;
    }

    var style = document.createElement('style');
    if (key) style.setAttribute('data-sh-font-key', key);
    style.textContent = template.content ? template.content.textContent : (template.textContent || '');
    document.head.appendChild(style);
  }

  function boot() {
    var templates = Array.prototype.slice.call(document.querySelectorAll('template[data-sh-deferred-fonts]'));
    if (!templates.length) return;

    if (!('IntersectionObserver' in window)) {
      templates.forEach(install);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var root = entry.target;
        var template = root.__shDeferredFontTemplate;
        install(template);
        observer.unobserve(root);
        try { delete root.__shDeferredFontTemplate; } catch (e) { root.__shDeferredFontTemplate = null; }
      });
    }, { rootMargin: '900px 0px' });

    templates.forEach(function (template) {
      var root = template.nextElementSibling;
      if (!root) {
        install(template);
        return;
      }
      root.__shDeferredFontTemplate = template;
      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
